import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { AgendamentoDespesa } from 'src/app/admihair/api/dto/agendamento-despesa';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { TipoPagamento } from 'src/app/admihair/api/dto/tipo-pagamento';
import { AgendamentoDespesaService } from 'src/app/admihair/service/agendamento-despesa.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { TipoPagamentoService } from 'src/app/admihair/service/tipo-pagamento.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-agendamento-despesa-editar',
  templateUrl: './agendamento-despesa-editar.component.html',
  styleUrls: ['./agendamento-despesa-editar.component.scss']
})
export class AgendamentoDespesaEditarComponent implements OnInit {

  permissaoEditar: boolean = false;
  loading: boolean = true;
  id?: number;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  empresaSelecionada?: Empresa;
  progressoRequisicao: boolean = false;
  planosContaEmpresa: PlanoContaEmpresa[] = [];
  agendamentoDespesa?: AgendamentoDespesa;
  especificacao?: string;
  tiposPagamento: TipoPagamento[] = [];
  @ViewChild('f') form?: NgForm;

  constructor(private agendamentoDespesaService: AgendamentoDespesaService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private tipoPagamentoService: TipoPagamentoService,
    private utilStorageService: UtilStorageService,
    private activatedRouter: ActivatedRoute,
    private erroService: ErroService) { }



  ngOnInit(): void {
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_AGENDAMENTO_DESPESA');
    this.carregarIdAgendamento();
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    if (this.permissaoEditar) {
      this.carregarTiposPagamento();
    }
  }

  atualizar() {
    this.progressoRequisicao = true;
    if (this.agendamentoDespesa?.operador) {
      this.agendamentoDespesa.operador = this.utilStorageService.getUser().usuario.id;
    }
    this.agendamentoDespesaService.atualizar(this.agendamentoDespesa, this.id).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.rolarTela();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    });

  }

  carregarAgendamento() {
    this.agendamentoDespesaService.buscarPorId(this.id).subscribe({
      next: (data: AgendamentoDespesa) => {
        this.agendamentoDespesa = data;

        if (this.agendamentoDespesa.dataVencimento)
          this.agendamentoDespesa.dataVencimento = new Date(this.agendamentoDespesa.dataVencimento + 'T05:00:00Z');

        if (this.agendamentoDespesa.competencia)
          this.agendamentoDespesa.competencia = new Date(this.agendamentoDespesa.competencia + 'T05:00:00Z');

        if (this.agendamentoDespesa.dataFluxo)
          this.agendamentoDespesa.dataFluxo = new Date(this.agendamentoDespesa.dataFluxo + 'T05:00:00Z');

        this.loading = false;

      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  carregarPlanosContas() {
    this.planoContaEmpresaService.listarConfiguraveisPorEmpresa(this.empresaSelecionada?.id)
      .subscribe({
        next: (data: PlanoContaEmpresa[]) => {
          this.planosContaEmpresa = data;
          this.carregarAgendamento();
        },
        error: (err: any) => {
          this.loading = false;
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
        }
      })
  }

  carregarTiposPagamento() {
    this.tipoPagamentoService.listarPorEmpresaEOperacaoDespesa(this.empresaSelecionada?.id)
      .subscribe({
        next: (data: TipoPagamento[]) => {
          this.tiposPagamento = data;
          this.carregarPlanosContas();
        },
        error: (err: any) => {
          this.loading = false;
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
        }
      })
  }

  carregarIdAgendamento() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }
  }

  verificarContaFornecedor(id: number): boolean {
    const plano = this.planosContaEmpresa.find(p => p.id === id);
    return plano ? plano.codigo === 22 : false;
  }

  verificarPermissao(nome: string): boolean {
    return AuthUtil.verificarPermissao(nome);
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  limparFormulario() {
    this.form?.reset();
  }

  ocultarMensagem() {
    if (this.messagemVisivel) {
      this.messagemVisivel = false;
    }
  }
}
